import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import removeAtIndex from 'utils/immutability/removeAtIndex';

export type RoutesFiltersOptionsState = {
  fetching: string[];
  airportsFrom: Record<string, string[]> | null;
  airportsTo: Record<string, string[]> | null;
  carrier: { value: string; label: string }[] | null;
};

const initialState: RoutesFiltersOptionsState = {
  fetching: [],
  airportsFrom: null,
  airportsTo: null,
  carrier: null,
};

function pushToFetchingFunction(state: RoutesFiltersOptionsState, action: PayloadAction<string>) {
  return {
    ...state,
    fetching: [...state.fetching, action.payload],
  };
}

function removeFromFetchingFunction(state: RoutesFiltersOptionsState, action: PayloadAction<string>) {
  const index = state.fetching.indexOf(action.payload);

  if (index === -1) {
    return state;
  }

  return {
    ...state,
    fetching: removeAtIndex(state.fetching, index),
  };
}

function setAirportsFromFunction(
  state: RoutesFiltersOptionsState,
  action: PayloadAction<RoutesFiltersOptionsState['airportsFrom']>
) {
  return {
    ...state,
    airportsFrom: action.payload,
  };
}

function setAirportsToFunction(
  state: RoutesFiltersOptionsState,
  action: PayloadAction<RoutesFiltersOptionsState['airportsTo']>
) {
  return {
    ...state,
    airportsTo: action.payload,
  };
}

function setCarrierFunction(
  state: RoutesFiltersOptionsState,
  action: PayloadAction<RoutesFiltersOptionsState['carrier']>
) {
  return {
    ...state,
    carrier: action.payload,
  };
}

function resetStateFunction() {
  return initialState;
}

const slice = createSlice({
  name: 'flightRoutes.filters.options',
  initialState,
  reducers: {
    pushToFetching: pushToFetchingFunction,
    removeFromFetching: removeFromFetchingFunction,
    setAirportsFrom: setAirportsFromFunction,
    setAirportsTo: setAirportsToFunction,
    setCarrier: setCarrierFunction,
    resetState: resetStateFunction,
  },
});

export const {
  pushToFetching,
  removeFromFetching,
  setAirportsFrom,
  setAirportsTo,
  setCarrier,
  resetState,
} = slice.actions;
export default slice.reducer;
